// extracted by mini-css-extract-plugin
var _1 = "I8AaM_UdJd";
export { _1 as "root" }
